import * as types from '../types'
import axios from 'axios'

const state = {
  filters: [],
  filtersBruto: [],
  loadingFilters: false,
  products: [],
  loadingProducts: false,
  sides: [],
  loadingSides: false
}

const getters = {
  filters: (state) => {
    return state.filters
  },
  filtersBruto: (state) => {
    return state.filtersBruto
  },
  loadingFilters: (state) => {
    return state.loadingFilters
  },
  products: (state) => {
    return state.products
  },
  loadingProducts: (state) => {
    return state.loadingProducts
  },
  sides: (state) => {
    return state.sides
  },
  loadingSides: (state) => {
    return state.loadingSides
  },
  product: (state) => (id) => {
    return state.products.find(product => product.id === id)
  },
  side: (state) => (code) => {
    return state.sides.find(side => side.code === code)
  }
}

const mutations = {
  [types.MUTATE_FILTERS]: (state, filters) => {
    state.filters = filters
  },
  [types.MUTATE_FILTERS_BRUTO]: (state, filtersBruto) => {
    state.filtersBruto = filtersBruto
  },
  [types.MUTATE_LOADING_FILTERS]: (state, loadingFilters) => {
    state.loadingFilters = loadingFilters
  },
  [types.MUTATE_PRODUCTS]: (state, products) => {
    state.products = products
  },
  [types.MUTATE_LOADING_PRODUCTS]: (state, loadingProducts) => {
    state.loadingProducts = loadingProducts
  },
  [types.MUTATE_SIDES]: (state, sides) => {
    state.sides = sides
  },
  [types.MUTATE_LOADING_SIDES]: (state, loadingSides) => {
    state.loadingSides = loadingSides
  }
}

const actions = {
  [types.FETCH_PRODUCTS]: ({ commit }) => {
    commit(types.MUTATE_LOADING_PRODUCTS, true)

    axios
      .get('/products.json')
      .then(res => {
        commit(types.MUTATE_PRODUCTS, res.data.products)
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        commit(types.MUTATE_LOADING_PRODUCTS, false)
      })
  },
  [types.FETCH_FILTERS]: ({ commit }) => {
    commit(types.MUTATE_LOADING_FILTERS, true)

    axios
      .get('/filters.json')
      .then(res => {
        commit(types.MUTATE_FILTERS, res.data.filters)
        commit(types.MUTATE_FILTERS_BRUTO, res.data.filtersBruto)
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        commit(types.MUTATE_LOADING_FILTERS, false)
      })
  },
  [types.FETCH_SIDES]: ({ commit }) => {
    commit(types.MUTATE_LOADING_SIDES, true)

    axios
      .get('/sides.json')
      .then(res => {
        let data = res.data.sides
        // Adding one empty entry at the top (disabled for now, sides seems to be mandatory...)
        // data.unshift({
        //   code: 0,
        //   label: 'Geen toplaag',
        //   image: '',
        //   description: '',
        //   group: ''
        // })
        commit(types.MUTATE_SIDES, data)
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        commit(types.MUTATE_LOADING_SIDES, false)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
